var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbody modulewrap"},[_c('div',{staticClass:"pagemain realwrap"},[_c('div',{staticClass:"editor",domProps:{"innerHTML":_vm._s(_vm.$common.langinfo(_vm.pageinfo.content,_vm.pageinfo.content_en))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }